import {delayedInit} from "@/laraberg_frontend/general"

delayedInit(initLoginPopup, 300)

async function initLoginPopup() {
    const toLogin = document.querySelector("#to-login")
    if (toLogin) {
        toLogin.addEventListener(
            "click",
            async (e) => {
                e.preventDefault()
                const {openLoginRegistrationPopup} = await import("@/libs/helpers.ts")
                openLoginRegistrationPopup()
            },
            {passive: true}
        )
    }
}
